const AIRCRAFT_NAME_POSITION = {
  'Dreamliner 787-9': 1,
  'Dreamliner 787-8': 2,
  'Boeing 737-800': 3,
  'Boeing 737': 4,
  'Embraer 190': 5,
  'Boeing 737-900': 6,
};

export default AIRCRAFT_NAME_POSITION;